__turbopack_context__.v({
  "jobCard": "vk191G_jobCard",
  "jobCard__code": "vk191G_jobCard__code",
  "jobCard__context": "vk191G_jobCard__context",
  "jobCard__hoursLabel": "vk191G_jobCard__hoursLabel",
  "jobCard__hoursValue": "vk191G_jobCard__hoursValue",
  "jobCard__menu": "vk191G_jobCard__menu",
  "jobCard__meta": "vk191G_jobCard__meta",
  "jobCard__name": "vk191G_jobCard__name",
  "jobCard__right": "vk191G_jobCard__right",
});
